import {
    FORECAST,
    PLACE,
    REVERSE_FORECAST,
    REVERSE_TRICAST,
    SHOW,
    TO_WIN,
    TO_WIN_EW,
    TRICAST
} from '../constants/identifiers';
import {getText} from '../../../../../helpers/localization';

export function getBetTypeText(betSelection, store) {
    let betType;
    let racersList = betSelection.bets[0].racers;
    switch (betSelection.bets[0].betType.name) {
        case TO_WIN.name:
            betType = getText('TO_WIN', store);
            break;
        case TO_WIN_EW.name:
            betType = getText('TO_WIN', store);
            break;
        case FORECAST.name:
            betType = getText('FORECAST', store);
            break;
        case TRICAST.name:
            betType = getText('TRICAST', store);
            break;
        case REVERSE_FORECAST.name:
            if (racersList.length === 2) {
                betType = getText('REVERSE_FORECAST', store);
            } else {
                betType = getText('COMBINATION_FORECAST', store) + ' (' + getNumberOfCombinations(betSelection) + ')';
            }
            break;
        case REVERSE_TRICAST.name:
            betType = getText('COMBINATION_TRICAST', store) + ' (' + getNumberOfCombinations(betSelection) + ')';
            break;
        default:
            betType = '';
            break;
    }
    return betType;
}

export function getNumberOfCombinations(betSelection) {
    let racersList = betSelection.bets[0].racers;
    switch (betSelection.bets[0].betType.name) {
        case REVERSE_FORECAST:
            if (racersList.length > 2) {
                return racersList.length * (racersList.length - 1);
            }
            break;
        case REVERSE_TRICAST:
            return racersList.length * (racersList.length - 1) * (racersList.length - 2);
        default:
            break;
    }
    return 1;
}

export function getOdd(betSelection) {
    let odd;
    let racer1;
    let racer2;
    let racer3;
    let racersList = betSelection.bets[0].racers;
    switch (betSelection.bets[0].betType.name) {
        case TO_WIN.name:
            odd = racersList[0].oddsFirst;
            break;
        case TO_WIN_EW.name:
            odd = racersList[0].oddsPlace;
            break;
        case PLACE.name:
            odd = racersList[0].oddsPlace;
            break;
        case SHOW.name:
            odd = racersList[0].oddsShow;
            break;
        case FORECAST.name:
            racer1 = racersList[0].num;
            racer2 = racersList[1].num;
            odd = betSelection.bets[0].event.priceList.forecast[racer1 + '-' + racer2];
            break;
        case REVERSE_FORECAST.name:
            racer1 = racersList[0].num;
            racer2 = racersList[1].num;
            odd = betSelection.bets[0].event.priceList.reverseForecast[racer1 + '-' + racer2];
            break;
        case TRICAST.name:
            racer1 = racersList[0].num;
            racer2 = racersList[1].num;
            racer3 = racersList[2].num;
            odd = betSelection.bets[0].event.priceList.tricast[racer1 + '-' + racer2 + '-' + racer3];
            break;
        case REVERSE_TRICAST.name:
            racer1 = racersList[0].num;
            racer2 = racersList[1].num;
            racer3 = racersList[2].num;
            odd = betSelection.bets[0].event.priceList.reverseTricast[racer1 + '-' + racer2 + '-' + racer3];
            break;
        default:
            break;
    }
    return odd;
}

export function getCombinedStake(betSelection) {
    let racersList = betSelection.bets[0].racers;
    let combinedStakeValue = 0;
    if (Number(betSelection.stake)) {
        switch (betSelection.bets[0].betType.name) {
            case TO_WIN_EW.name:
                combinedStakeValue = Number(betSelection.stake) * 2;
                break;
            case REVERSE_FORECAST.name:
                if (racersList.length > 2) {
                    combinedStakeValue = Number(betSelection.stake) * getNumberOfCombinations(betSelection);
                } else {
                    combinedStakeValue = Number(betSelection.stake);
                }
                break;
            case REVERSE_TRICAST.name:
                combinedStakeValue = Number(betSelection.stake) * getNumberOfCombinations(betSelection);
                break;
            default:
                combinedStakeValue = Number(betSelection.stake);
                break;
        }
    }

    return combinedStakeValue;
}


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/racing/helpers/betFunctions.js